"use strict";
var Observable_1 = require('../../Observable');
var windowToggle_1 = require('../../operator/windowToggle');
Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
//# sourceMappingURL=windowToggle.js.map


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/~/rxjs/add/operator/windowToggle.js
// module id = ../../../../rxjs/add/operator/windowToggle.js
// module chunks = 4